










import { Vue, Component, Prop } from 'vue-property-decorator';
import { lazyInject } from '@/app/container';
import { BreadcrumbService, BreadcrumbServiceSymbol } from '../breadcrumb-service';
import { Link } from '@/app/shared/models';
import { getPageLocationByHref } from '@/app/shared/utils/route-utils';
import aspectStoreModule from '@/app/aspect/apsect-state';

@Component
export default class BreadcrumbComponent extends Vue {
  @Prop({
    default: null
  })
  public page: string|null;

  @Prop({
    default: null
  })
  public items: Link[]|null;

  @Prop({
    default: false
  })
  public secondary: boolean;

  @Prop({
    default: false
  })
  public visible: boolean;

  @lazyInject(BreadcrumbServiceSymbol)
  private breadcrumbService: BreadcrumbService;

  public get itemsInternal(): Link[] {
    if (this.items !== null) {
      return this.items;
    }

    if (this.page === null || aspectStoreModule.selectedChapter === null) {
      return [];
    }

    const result = this.breadcrumbService.createItems(this.page, aspectStoreModule.selectedChapter);
    return result.links;
  }

  public getPageLocationByHref(href: string) {
    return getPageLocationByHref(href);
  }
}
